var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:{'visible' : _vm.visible},style:(_vm.position),attrs:{"variant":_vm.putColor},on:{"click":_vm.automaticScroll}},[_c('v-icon',{attrs:{"name":_vm.putIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }